// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiInventoryPortal } from "@store/apiSlices/apiSlices";

// interfaces.
import { ModelError } from "@store/apiSlices/interfaces/interfaces";
import { VimDataLog } from "../interfaces/interfaces";

// interfaces.
interface VimLogResponse {
  message: string;
  success: boolean;
}

export const postVim = apiInventoryPortal.injectEndpoints({
  endpoints: (builder) => ({
    postVim: builder.mutation({
      query: (data: VimDataLog) => ({
        body: data,
        method: "POST",
        url: "/post_vim_log",
      }),
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "postVim",
        };
        return modelError;
      },
      transformResponse: (response: VimLogResponse): VimLogResponse => {
        return response;
      },
    }),
  }),
});

export const { usePostVimMutation } = postVim;
